import {mapState, mapMutations, mapGetters} from 'vuex';
import TransactionProService from '../../transaction-pro-service';
import SigninDialog from '@/views/signin/signin-dialog/signin-dialog.vue';
import AssetsInfo from '@/components/assets-info/assets-info.vue';
import Bus from '../../bus.js';
export default {
  components: {
    SigninDialog,
    AssetsInfo
  },
  props: ['projectInfo', 'bidInfo', 'type'],
  data() {
    return {
      checkedes: true,
      disabled: false, // fale 可以选择 禁选
      landInfo: {detail: []},
      isShowsignUpBtn: false, // 报名按钮的展示
      dialogVisible: false
    };
  },
  created() {
  },
  mounted() {
    Bus.$on('msg', () => {
      this.checkCurrentUserSign();
    });
  },
  computed: {
    ...mapState({
      assetsBidInfos: ({transaction}) => transaction.assetsBidInfos
    }),
    ...mapGetters([
      'isSignin',
      'assetsBidInfos'
    ]),
    sumMarginText() {
      return this.assetsBidInfos.length * this.projectInfo.sumMargin;
    }
  },
  watch: {
    projectInfo (newValue) {
      if (newValue) {
        if (this.isSignin) {
          this.checkCurrentUserSign();
        } else {
          // this.isShowsignUpBtn = true;
          this.checkCurrentUserSignForUnlogin();
        }
      }
    }
  },
  methods: {
    // 判断立即报名按钮是否展示
    checkCurrentUserSign () {
      TransactionProService.checkCurrentUserSign(this.$route.query.id).then(res => {
        // 当报名按钮正常显示的时候 多选框可以选择 单独也可以选择 反之
        if (res && res.code === '0' && res.data && res.data.signFlag) {
          this.isShowsignUpBtn = true; // 按钮展示 的情况下先默认全选中
          // 判断标的是否可以点击 之前选中过则不能重复点击
          this.landInfo.detail.forEach(item => {
            res.data.bidList.find(i => {
              if(item.bidId === i) {
                this.disabled = true;
                item.checked = false;
                item.isDisable = false; // 当有重复的标的信息的时候 添加字段不让点击
              }
            });
          });
          // 可以选中的标的信息加载到缓存
          let add = this.landInfo.detail.filter(item => item.checked);
          this.UPDATE_TRANSACTION_INFO(add);
        } else {
          this.isShowsignUpBtn = false;
          this.checkedes = false;
          this.disabled = true; // 复选框不可点击
          // 默认全选中
          this.landInfo.detail.map(item => {item.checked = false; return item;});
        }
      });
    },
    checkCurrentUserSignForUnlogin () {
      TransactionProService.checkCurrentUserSignForUnlogin(this.$route.query.id).then(res => {
        if (res && res.code === '0') {
          if (res.data && res.data.signFlag) {
            this.isShowsignUpBtn = true;
            return;
          }
          this.isShowsignUpBtn = false;
        }
      });
    },
    // 更新地块数据
    ...mapMutations([
      'UPDATE_TRANSACTION_INFO'
    ]),
    // 弹框展示
    onSignUp () {
      if (this.isSignin) {
        this.$emit('onSignUp');
      } else {
        this.dialogVisible = true;
      }
    }
  }
};
